import { Fragment, type ReactNode } from "react";

/** Fills {placeholders}: fmt("{n} videos", { n: "12" }) → "12 videos". */
export function fmt(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m));
}

/** Like fmt, but placeholders can be elements (links): returns the pieces in order. */
export function rich(template: string, vars: Record<string, ReactNode>): ReactNode {
  const parts = template.split(/(\{\w+\})/g);
  return parts.map((p, i) => {
    const k = p.match(/^\{(\w+)\}$/)?.[1];
    return <Fragment key={i}>{k && k in vars ? vars[k] : p}</Fragment>;
  });
}
